<template>
  <div class="imgUploadBg " :style="{ width: width, height: height }">
    <div class="pr w100b h100b">
      <!-- 未上传 -->
      <div class="imgUpload-noFile dCC w100b h100b postionA" v-if="!showUrl">
        <!-- 自定义上传图片的封面 -->
        <slot name="all" v-if="$slots.all"></slot>
        <template v-else>
          <!-- <div class="dCC imgUpload-noFile-btn">
          </div> -->
        </template>
      </div>

      <input type="file" class="input_upload_other_file" :style="{ width: width, height: height }" ref="input_upload_file" data-filetype="doc,pdf,png,jpg" @change="getFile">

      <!-- 已上传 -->
      <div class="imgUpload-file dCC w100b h100b postionA" v-if="showUrl">
        <img :src="showUrl" alt="">
        <div class="imgUpload-file-btn postionA">
          <div class="jCAround aic h100b">
            <span @click="showImgStatus = true">预览</span>
            <span @click="reUpload">重新上传</span>
          </div>

        </div>
      </div>

      <!-- 上传中 -->
      <div class="w100b h100b pa t0 r0" v-if="params.loadding && loadding">
        <Spin class="wh100b h100b ivu_wh100" fix>
          <div class="wh100b dCC br4 bg0004">
            <Icon type="ios-time" class="dp-c-waite f22" />
            <div class="fb mt5 f14 cfff">上传中</div>
          </div>
        </Spin>
      </div>
    </div>

    <div class="popups_style popupsEvent" v-if="showImgStatus" @click="showImgStatus = false">
      <div class="df fDC aic jcc p15  pac w40b  ">
        <!--关闭按钮-->
        <Icon type="md-close close_style" class="f18 c999 cp bgfff br50b close_style" @click="showImgStatus = false" />
        <img :src="showUrl" :alt="showUrl" class="w100b ">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      loadding: false,
      showImgStatus: false,
      fileUrl: ''
    }
  },
  props: {
    showUrl: String, // 图片地址
    params: {
      ocr: false,
      loadding: false,// 上传中 Loading 效果
      isShowImg: true,// 图片预览
      isReUpload: false, // 是否展示重新上传按钮
      ocr: { // ocr 识别
        picType: ''// 上传图片类型 用于OCR识别
      },
      required: true
    },
    fieldName: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '80px'
    },
    height: {
      type: String,
      default: '40px'
    },
    format: {
      type: Array,
      default: []
    }
  },
  computed: {},
  created () { },
  mounted () {
    console.log(this.params);
  },
  methods: {

    // OCR识别
    ocrDiscern: function (ocrType, base, callback) {
      this.sendOther({
        url: '/web/aliocr/ocrInfo/' + ocrType,
        data: { image: base }
      }, (result) => {
        if (result.data.message) {
          if (ocrType != 'idCardFace' && ocrType != 'idCardBack') {
            this.$Message.success(result.data.message);
          }
        }
        callback ? callback(result) : "";

      }, (result) => {
        console.log("其他回调", result);
      })
    },
    // 上传图片
    getFile (e) {
      var that = this;
      that.loadding = true
      let file = e.target.files[0]
      that.fileUrl = ''
      console.log(e);
      const rules = RegExp("" + ".(" + this.format.join('|') + ")" + "$", "g")
      console.log('this.format', rules, e.target.value);

      if (!rules.test(e.target.value)) {
        this.$Message.error(`类型必须为${this.format.join('/')}格式`);
        $(that).val("");
      } else {
        // 图片格式
        if (/.(gif|jpg|jpeg|png|GIF|JPG|png)$/.test(e.target.value)) {
          this.imgToBase64(e, function (base, fileTarget) {
            that.ossUpload(fileTarget, (data) => {
              if (!that.params.ocr) {
                that.$emit('change', data, that.fieldName, file.name,)
              } else {
                let picType = that.params.ocr.picType
                // OCR识别
                that.$emit('change', data, '', picType)
                var ocrType = "";
                if (picType == 'blicPicOss') {
                  // 营业执照
                  ocrType = "businessLicense";
                } else if (picType == 'aupPicAOss' || picType == 'lepPicAOss') {
                  // 人像面（正面）
                  ocrType = "idCardFace";
                } else if (picType == 'aupPicBOss' || picType == 'lepPicBOss') {
                  // 国徽面（背面）
                  ocrType = "idCardBack";
                }
                // that.addLoading();
                that.ocrDiscern(ocrType, base, function (result) {
                  that.loadding = false
                  that.$emit('change', data, result.data, picType, that.fieldName)
                });
              }
            })
          });
        } else {
          if (file) {
            that.ossUpload(file, (data) => {
              that.$emit('change', file.name, data.url, that.fieldName)
            })
          }
        }
      }

    },

    // 重新上传
    reUpload () {
      this.$refs['input_upload_file'].click()
    },
  }
}
</script>

<style lang="less" scoped>
.postionA {
  position: absolute;
  top: 0;
  left: 0;
}

.imgUploadBg {
  position: relative;
  width: 80px;
  height: 80px;
  // border: 1px solid #f4f4f4;
  cursor: pointer;
  .imgUpload-noFile-btn {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .imgUpload-file {
    img {
      max-width: 100%;
      max-height: 100%;
    }
    .imgUpload-file-btn {
      width: 100%;
      height: 100%;
      display: none;
      background-color: rgba(0, 0, 0, 0.3);
      line-height: 100%;
      color: #fff;
      span {
        cursor: pointer;
      }
    }
    &:hover {
      .imgUpload-file-btn {
        display: block;
      }
    }
  }
}
.input_upload_other_file {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
</style>
<style lang="less">
.blicPicOss {
  width: 140px !important;
  height: 140px !important;
  background: url(~@/assets/img/account/bg_yingyezhizhao_sc.png) no-repeat
    center center;
  border: none;
  background-size: contain;
}
.lepPicAOss {
  // width: 200px !important;
  // height: 130px !important;
  background: url(~@/assets/img/account/bg_shenfenzhengrenxiang_sc.png)
    no-repeat center center;
  border: none;
  background-size: contain;
}
.lepPicBOss {
  // width: 200px !important;
  // height: 130px !important;
  background: url(~@/assets/img/account/bg_shenfenzhengguohui_sc.png) no-repeat
    center center;
  border: none;
  background-size: contain;
}
.file {
  // width: 200px !important;
  // height: 130px !important;
  background: url(~@/assets/img/account/bg_kongbai_sc.png) no-repeat center
    center;
  border: none;
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/module/imgUpload.vue